<template>
  <div class="w-[96%] mx-auto" style="margin-top: 16px">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>患者基本信息</span>
        </div>
      </template>
      <el-form :model="patientForm" label-width="80px">
        <el-form-item label="患者姓名">
          <el-input v-model="patientForm.patientname"></el-input>
        </el-form-item>

        
        <el-form-item label="联系电话">
          <el-input v-model="patientForm.patientphone"></el-input>
        </el-form-item>
        <el-form-item label="诊断信息">
          <el-select
            v-model="patientForm.diagnosis"
            multiple
            filterable
            allow-create
            default-first-option
            :reserve-keyword="false"
            placeholder="请选择诊断信息"
          >
            <el-option-group
              v-for="group in diagnosisOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="检查报告" prop="medicalPhoto">
          <el-upload
            name="files"
            :limit="12"
            list-type="picture"
            multiple
            :on-success="handleFileSuccess"
            :http-request="uploadToLafnew"
          >
            <div class="flex items-center">
              <el-button slot="trigger" size="small" type="primary"
                >选择文件</el-button
              >
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 16px">
      <template #header>
        <div class="card-header">
          <span>接诊医院信息</span>
        </div>
      </template>
      <el-form :model="referralForm" label-width="80px">
        <el-form-item label="接诊医院">
          <el-select
            v-model="referralForm.referralhospital"
            placeholder="请选择医院"
            multiple
            filterable
            allow-create
            default-first-option
            :reserve-keyword="false"
          >
            <el-option
              v-for="item in hospitalOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="接诊科室">
          <el-select
            v-model="referralForm.referraldepartment"
            placeholder="请选择科室"
            multiple
            filterable
            allow-create
            default-first-option
            :reserve-keyword="false"
          >
            <el-option
              v-for="item in departmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="接诊医生">
          <el-input v-model="referralForm.referraldoctorName"></el-input>
        </el-form-item>
        <el-form-item label="接诊电话">
          <el-input v-model="referralForm.referraldoctorPhone"></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <div class="flex justify-end mt-4">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button @click="goBack">返回</el-button>
        </div>
      </template>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import { ReferalPatient, UploadFiles } from "../../api/ReferalPatient";
import { FILE_BASE_URL } from "../../api/baseUrl";
import { nanoid } from "nanoid";

const route = useRoute();
const router = useRouter();

const userinfo = ref({
  hospital: "",
  keshi: "",
  name: "",
  zhicheng: "",
  phone: "",
});

const patientForm = ref({
  patientname: "",
  patientphone: "",
  diagnosis: [],
  medicalPhoto: [],
});

const referralForm = ref({
  referralhospital: "",
  referraldepartment: "",
  referraldoctorName: "",
  referraldoctorPhone: "",
});

const hospitalOptions = [
  { label: "南通市肿瘤医院", value: "南通市肿瘤医院" },
  { label: "如皋市人民医院", value: "如皋市人民医院" },
  { label: "南通市第一人民医院", value: "南通市第一人民医院" },
  { label: "南通市第二人民医院", value: "南通市第二人民医院" },
  { label: "南通市第三人民医院", value: "南通市第三人民医院" },
  { label: "南通市第四人民医院", value: "南通市第四人民医院" },
  { label: "南通市中医院", value: "南通市中医院" },
  { label: "南通市妇幼保健院", value: "南通市妇幼保健院" },

  { label: "海门市人民医院", value: "海门市人民医院" },
  { label: "启东市人民医院", value: "启东市人民医院" },
  { label: "通州市人民医院", value: "通州市人民医院" },
  { label: "海安市人民医院", value: "海安市人民医院" },
];

const departmentOptions = [
  { label: "肿瘤内科", value: "肿瘤内科" },
  { label: "胃肠外科", value: "胃肠外科" },
  { label: "胸外科科", value: "胸外科" },
  { label: "泌尿外科", value: "泌尿外科" },
  { label: "妇科", value: "妇科" },
  { label: "放疗科", value: "放疗科" },
];

const diagnosisOptions = [
  {
    label: "呼吸系统肿瘤",
    options: [
      { label: "肺癌", value: "肺癌" },
      { label: "鼻咽癌", value: "鼻咽癌" },
    ],
  },
  {
    label: "心血管疾病",
    options: [
      { label: "高血压", value: "高血压" },
      { label: "冠心病", value: "冠心病" },
      { label: "中风", value: "中风" },
      { label: "心肌炎", value: "心肌炎" },
      { label: "心包炎", value: "心包炎" },
    ],
  },
  {
    label: "内分泌疾病",
    options: [
      { label: "糖尿病", value: "糖尿病" },
      { label: "甲状腺疾病", value: "甲状腺疾病" },
    ],
  },
  {
    label: "消化系统疾病",
    options: [
      { label: "胃溃疡", value: "胃溃疡" },
      { label: "肝炎", value: "肝炎" },
      { label: "肠癌", value: "肠癌" },
      { label: "肝癌", value: "肝癌" },
      { label: "胰腺癌", value: "胰腺癌" },
    ],
  },
  {
    label: "神经系统疾病",
    options: [
      { label: "帕金森病", value: "帕金森病" },
      { label: "阿尔茨海默病", value: "阿尔茨海默病" },
      { label: "抑郁症", value: "抑郁症" },
      { label: "焦虑症", value: "焦虑症" },
    ],
  },
  {
    label: "癌症",
    options: [
      { label: "乳腺癌", value: "乳腺癌" },
      { label: "前列腺癌", value: "前列腺癌" },
      { label: "皮肤癌", value: "皮肤癌" },
      { label: "胃癌", value: "胃癌" },
      { label: "食道癌", value: "食道癌" },
      { label: "宫颈癌", value: "宫颈癌" },
      { label: "卵巢癌", value: "卵巢癌" },
    ],
  },
  {
    label: "传染病",
    options: [
      { label: "艾滋病", value: "艾滋病" },
      { label: "结核病", value: "结核病" },
      { label: "流感", value: "流感" },
      { label: "水痘", value: "水痘" },
      { label: "麻疹", value: "麻疹" },
    ],
  },
  {
    label: "风湿免疫疾病",
    options: [
      { label: "类风湿性关节炎", value: "类风湿性关节炎" },
      { label: "骨关节炎", value: "骨关节炎" },
    ],
  },
  {
    label: "血液系统疾病",
    options: [
      { label: "白血病", value: "白血病" },
      { label: "淋巴瘤", value: "淋巴瘤" },
    ],
  },
];

onMounted(() => {
  try {
    Object.assign(userinfo.value, route.query);
    console.log("转诊资料填写页", userinfo.value);
  } catch (error) {
    console.error("获取信息时出错:", error);
  }
});

const goToRouter = (name, query) => {
  router.replace({ name, query }); // 传递用户信息
  //router.push({ name: "DoctorHome", query: userInfo }); // 传递用户信息
};

const handleFileSuccess = (response, file, fileList) => {
  console.log("文件上传响应:", response);

  if (!response) return;

  const { files } = response;

  if (!Array.isArray(patientForm.value.medicalPhoto)) {
    patientForm.value.medicalPhoto = [];
  }
  if (Array.isArray(files)) {
    files.forEach((res) => {
      patientForm.value.medicalPhoto.push(`${FILE_BASE_URL}/${res.filePath}`);
    });
  }

  ElMessage.success("文件上传成功");
  console.log("文件上传路径为:", patientForm.value.medicalPhoto);
};

const uploadToLafnew = async (options) => {
  const { file, onSuccess, onError } = options;

  const uploadToOwnServer = async (file) => {
    const formData = new FormData();
    formData.append("files", file);

    const userId = nanoid();
    formData.append("userId", userId);

    try {
      const response = await UploadFiles(formData);
      console.log("服务器响应:", response);
      onSuccess(response);
    } catch (error) {
      onError(error);
      ElMessage.error("文件上传失败");
    }
  };

  try {
    await uploadToOwnServer(file);
  } catch (error) {
    onError(error);
  }
};

const submitForm = async () => {
  console.log("提交表单", patientForm.value, referralForm.value);

  const formData = new FormData();
  formData.append("patientname", patientForm.value.patientname);
  formData.append("patientphone", patientForm.value.patientphone);
  formData.append(
    "medicalPhoto",
    JSON.stringify(patientForm.value.medicalPhoto)
  );
  formData.append("diagnosis", JSON.stringify(patientForm.value.diagnosis));

  const { hospital, keshi, name, zhicheng, phone } = userinfo.value;
  formData.append("hospital", hospital);
  formData.append("keshi", keshi);
  formData.append("name", name);
  formData.append("zhicheng", zhicheng);
  formData.append("phone", phone);

  // formData.append(
  //   "referralhospital",
  //   JSON.stringify(referralForm.value.referralhospital)
  // );
  // formData.append(
  //   "referraldepartment",
  //   JSON.stringify(referralForm.value.referraldepartment)
  // );

  formData.append("referralhospital", referralForm.value.referralhospital);
  formData.append("referraldepartment", referralForm.value.referraldepartment);
  formData.append("referraldoctorName", referralForm.value.referraldoctorName);
  formData.append(
    "referraldoctorPhone",
    referralForm.value.referraldoctorPhone
  );

  try {
    const result = await ReferalPatient(formData);
    ElMessage.success("提交成功");

    goToRouter("DoctorHome", userinfo.value);
    console.log(result);
  } catch (error) {
    alert("提交失败，请重试");
  }
};

const resetForm = () => {
  patientForm.value = {
    patientname: "",
    patientphone: "",
    diagnosis: [],
    medicalPhoto: [],
  };
  referralForm.value = {
    referralhospital: "",
    referraldepartment: "",
    referraldoctorName: "",
    referraldoctorPhone: "",
  };
};

const goBack = () => {
  router.go(-1);
};
</script>
